export default "__VITE_ASSET__DCDeHRjJ__"